module.exports = __webpack_public_path__ + "static/media/new4.1de4d7bd.png";